import * as moment from 'moment';
import { Component } from '@angular/core';
import { AlertController, NavParams, ViewController } from 'ionic-angular';

import { DayEntryModel, UserModel } from '../../../models/models';
import { ConfigurationProvider, DayEntryProvider, MealProvider, UserProvider } from '../../../providers/providers';

@Component({
  selector: 'page-dashboard-log-food',
  templateUrl: 'dashboard-log-food.html'
})
export class DashboardLogFoodPage {
  dayEntry: DayEntryModel;
  deleteFoodItems: number[] = [];
  entryTime: moment.Moment = moment();
  foodList: any[] = [];
  foodListSearch: any[] = [];
  user: UserModel;

  constructor(
    private alertCtrl: AlertController,
    private config: ConfigurationProvider,
    private dayEntryProvider: DayEntryProvider,
    private mealProvider: MealProvider,
    private params: NavParams,
    private userProvider: UserProvider,
    private viewCtrl: ViewController) {
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  dismissView(item = null) {
    // dismiss the form
    this.viewCtrl.dismiss({
      saved: true,
      date: item ? item.Date : null
    });
  }

  doGetItems(ev: any) {
    // Reset items back to all of the items
    this.foodListSearch = [];
    
    // set val to the value of the searchbar
    let val = ev.target.value;

    // if the value is an empty string don't filter the items
    if (val && val.trim() != '') {
      this.foodListSearch = this.foodList.filter((item) => {
        return (item.Name.toLowerCase().indexOf(val.toLowerCase()) > -1);
      });
    }
  }

  doRemove(item: any) {
    let confirm = this.alertCtrl.create({
      title: `Remove ${item.Name}?`,
      message: 'Are you sure?',
      buttons: [
        {
          text: 'Cancel',
        },
        {
          text: 'Remove',
          handler: () => {
            if (item.DayEntryFoodId) {
              this.deleteFoodItems.push(item.DayEntryFoodId);
            }
            this.dayEntry.FoodItems = this.dayEntry.FoodItems.filter((m: any) => m !== item);
          }
        }
      ]
    });
    confirm.present();
  }

  doSave() {
    if (this.formIsValid()) {
      this.config.showLoading('Saving...');

      // delete food items, if any
      if (this.deleteFoodItems.length > 0) {
        this.dayEntryProvider.DeleteFoodItems(this.deleteFoodItems);
      }

      // save day entry food items
      this.dayEntryProvider.Save(this.user, this.dayEntry).then((res: DayEntryModel) => {

        // if day entry is today, update the user's body weight
        if (moment(this.dayEntry.Date).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') && this.dayEntry.BodyComposition.Weight !== this.user.BodyWeight) {
          this.userProvider.SaveBodyWeight(this.user._id, this.dayEntry.BodyComposition.Weight);
        }

        // reset and dismiss
        this.config.dismissLoading();
        this.dismissView(res);
      });
    }
  }

  doSelectFood(item: any) {
    let inputs = [
      {
        name: 'time',
        type: 'time',
        placeholder: 'Time',
        value: moment(this.entryTime).format('HH:mm')
      }
    ];

    if (!item.IsMeal) {
      inputs.push({
        name: 'serving',
        type: 'serving',
        placeholder: 'Servings',
        value: '1'
      });
    }

    const prompt = this.alertCtrl.create({
      title: 'Log Food',
      message: item.Name,
      inputs: inputs,
      buttons: [
        {
          text: 'Cancel'
        },
        {
          text: 'Add',
          handler: data => {
            item.Time = data.time;
            this.entryTime = moment(item.Time, 'HH:mm');

            if (!item.IsMeal) {
              item.Serving = data.serving;
              if (this.dayEntry.FoodItems.find((x: any) => {
                return x === item;
              }) === undefined) {
                this.dayEntry.FoodItems.push(item);
                // Reset items back to all of the items
                // this.foodListSearch = [];
              }
            }
            else {
              // load meal
              this.mealProvider.LoadMealItems(item.MealId).then((foods: any[]) => {
                foods.forEach(food => {
                  this.dayEntry.FoodItems.push({
                    IsMeal: true,
                    MealId: item.MealId,
                    FoodId: food.FoodId,
                    Time: item.Time,
                    MealName: item.Name,
                    Name: food.Name,
                    Brand: food.Brand,
                    Portion: food.Portion,
                    Serving: food.Serving,
                    ServingSize: food.ServingSize,
                    Nutrition: food.Nutrition,
                    icon: "arrow-dropdown",
                    showDetails: false
                  } as any);
                });
              });
            }
          }
        }
      ]
    });
    prompt.present();
  }

  formIsValid() {
    if (!this.dayEntry.FoodItems) {
      this.config.showAlert('Error', 'Must search for and select at least one food item or meal.');
      return false;
    }

    // // check if item exists
    // if (this.mealProvider.Exists(this.item)) {
    //   this.config.showAlert('Error', 'Meal with this name and ingredients already exists!');
    //   return false;
    // }

    return true;
  }

  ionViewWillLoad() {
    this.dayEntry = this.params.get('dayEntry');
    this.user = this.params.get('user');

    this.loadFoodItems();
  }

  loadFoodItems() {
    this.config.showLoading();

    this.dayEntryProvider.LoadFoodSearch().then((items: any[]) => {
      items.map(x => {
        x.showDetails = false;
        x.icon = 'arrow-dropright';
      });
      this.foodList = items;

      // load food items for this day entry, if any
      this.dayEntryProvider.LoadFoodItems(this.user._id, this.dayEntry, true).then((dayEntry: any) => {
        
        let time = '';
        dayEntry.FoodItems.forEach(x => {
          x.showDetails = false;
          x.icon = 'arrow-dropright';
          
          if (time !== x['TimeDisplay']) {
            time = x['TimeDisplay'];
            x['new_time'] = true;
          }
        });
        this.dayEntry = dayEntry;
        this.config.dismissLoading();
      });
    });
  }

  toggleDetails(item) {
    if (item.showDetails) {
      item.showDetails = false;
      item.icon = 'arrow-dropright';
    }
    else {
      item.showDetails = true;
      item.icon = 'arrow-dropdown';
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/dashboard/nutrition/dashboard-log-food.ts